// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"173":"64fe338eb9506c39","888":"b743e3659dd84892"}[chunkId] + ".css";
};